<template>
  <div v-if="products_length > on_page" class="pagination">
    <div class="pagination__pagination">
      <!-- <div
        @click.prevent="prevPage"
        class="pagination-button pagination-button_arrow prev"
      ></div> -->

      <div
        class="pagination-button pagination-button_number"
        :class="item.content == current_page ? 'disabled ' : ''"
        v-for="item in pages"
        :key="item.content"
      >
        <a
          :href="pageHref(item.content)"
          v-if="item.content != '...' && item.content != current_page"
        >
          {{ item.content }}
        </a>
        <div
          class="disabled"
          :href="pageHref(item.content)"
          v-else-if="item.content != '...' && item.content == current_page"
        >
          {{ item.content }}
        </div>
        <div class="disabled" v-else>
          {{ item.content }}
        </div>
      </div>

      <!-- <div
        @click.prevent="nextPage"
        class="pagination-button pagination-button_arrow next"
      ></div> -->
    </div>
    <!-- <div class="pagination__go-to">
      <div class="pagination__go-to-label pagination__go-to-label_pc">
        Перейти на страницу:
      </div>
      <div class="pagination__go-to-label pagination__go-to-label_mobile">
        К странице:
      </div>
      <div class="pagination__go-to-input-group">
        <input
          @change="setPage($event)"
          type="text"
          class="input-v2 input-v2_medium"
          :placeholder="count_pages"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getPaginationItems } from "../../utils/pagination";

export default {
  name: "Pagination",
  computed: {
    ...mapGetters({
      on_page: "group_info/GET_ON_PAGE",
      products_length: "group_info/GET_PRODUCTS_LENGTH",
      current_page: "group_info/GET_CURRENT_PAGE",
      count_pages: "group_info/GET_COUNT_PAGES",
      next_page: "group_info/GET_NEXT_PAGE",
      prev_page: "group_info/GET_PREV_PAGE",
    }),
    pages() {
      return getPaginationItems({
        total: this.count_pages,
        current: this.current_page,
        pageRange: 3,
      });
    },
  },
  updated() {
    window.url_helpers.set_page(
      this.$store.getters["group_info/GET_CURRENT_PAGE"]
    );
  },
  beforeMount() {
    let result = window.url_helpers.get_page();
    if (result != null) {
      this.$store.dispatch("group_info/SET_CURRENT_PAGE", parseInt(result));
    }
  },
  methods: {
    pageHref(page) {
      page = parseInt(page);

      const url = new URL(location.href);

      page === 1
        ? url.searchParams.delete("page")
        : url.searchParams.set("page", page);

      return url.toString();
    },
    prevPage() {
      this.$store.dispatch("group_info/PREV_PAGE");
    },
    nextPage() {
      this.$store.dispatch("group_info/NEXT_PAGE");
    },
    setPage(event) {
      let value = 0;
      if (typeof event == "object") {
        value = parseInt(event.target.value);
      } else {
        value = parseInt(event);
      }
      if (value > 0 && value <= this.count_pages) {
        this.$store.dispatch("group_info/SET_CURRENT_PAGE", value);
      }
    },
  },
};
</script>
